import { Injectable } from '@angular/core'
import { PaymentIntent } from '@stripe/stripe-js'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { CreatePaymentIntentPayload } from '../model/payments'
import { AttachPaymentMethodInterface } from '../model/payments/tilled'
import { AuthenticatedRestService } from './auth-rest.service'

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends AuthenticatedRestService {

  createPaymentIntent(payload: CreatePaymentIntentPayload): Observable<PaymentIntent> {
    return this.post<PaymentIntent>('/payments/create-payment-intent', payload).pipe(
      map((resp) => resp.data),
    )
  }

  createSetupIntent(patientId: string) {
    return this.post<string>(`/payments/patients/${patientId}/setup-intent`, {}).pipe(
      map((response) => response.data),
    )
  }

  attachTilledPaymentMethodToCustomer(id: string, patientId: string) {
    const route = `/payments-tilled/methods/attach`
    return this.put<AttachPaymentMethodInterface>(route, { id, patientId }).pipe(
      map((resp) => {
        return resp.data
      }),
    )
  }
}
